<template>
  <v-row>
    <v-row>
      <v-col class="align-left">
        <ExpandCollapseToggle
          id="tunnelsPanelToggle"
          @toggleAllPanels="toggleAllPanels"
          styleClass="mt-3"
          :panel="panel"
        />
      </v-col>
      <v-col class="align-right mt-2">
        <ValidationCountsHeader v-if="moduleType == MODULE_TYPES.MANAGEMENT" />
      </v-col>
    </v-row>
    <v-expansion-panels v-model="panel" multiple color="#fff">
      <v-expansion-panel value="tunnelDetails" class="mt-5">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="panel.includes('tunnelDetails')" icon="fa-solid fa-minus" />
          <v-icon v-else icon="fa-solid fa-plus" />
          <h3>Tunnel Details</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <h3 class="withBackground px-2 my-2">Structure Type and Material Items</h3>
          <v-row>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <LabelText
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                textXl="4"
                textLg="4"
                textMd="4"
                textSm="4"
                id="number_number_of_bores"
                label="S.1 Number of Bores"
                v-model="numBores"
                type="number"
                maxlength="22"
              >
              </LabelText>
              <LabelSelect
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="4"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="S.2 Tunnel Shape"
                id="select_Tunnel_Shape"
                :refTable="REFERENCE_TABLE.TUNNEL_SHAPE"
                v-model="tunnelShape"
              />
              <LabelSelect
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="4"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="S.3 Portal Shape"
                id="select_Portal_Shape"
                :refTable="REFERENCE_TABLE.PORTAL_SHAPE"
                v-model="portalShape"
              />
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <LabelSelect
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="4"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="S.4 Ground Conditions"
                id="select_Ground_Conditions"
                :refTable="REFERENCE_TABLE.GROUND_CONDITION"
                v-model="groundCondition"
              />
              <LabelSelect
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="4"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="S.5 Complex"
                id="select_Complex"
                :refTable="REFERENCE_TABLE.COMPLEX"
                v-model="complex"
              />
            </v-col>
          </v-row>

          <h3 class="withBackground px-2 my-2">Age and Service Items</h3>
          <v-row>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <LabelSelect
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="4"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="A.8 Service in Tunnel"
                id="select_Service_in_Tunnel"
                :refTable="REFERENCE_TABLE.SERVICE_IN_TUNNEL"
                v-model="svcInTunnel"
              />
            </v-col>
          </v-row>
          <h3 class="withBackground px-2 my-2">Classification Items</h3>
          <v-row>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <LabelSelect
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="4"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="C.3 Direction of Traffic"
                id="select_Direction_of_Traffic"
                :refTable="REFERENCE_TABLE.DIRECTION_OF_TRAVEL"
                v-model="dirOfYTraffic"
              />
              <LabelSelect
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="4"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="C.4 Toll"
                id="select_Toll"
                :refTable="REFERENCE_TABLE.TOLL"
                v-model="toll"
              />
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <LabelSelect
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="4"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="C.7 Functional Classification"
                id="select_Functional_Classification"
                :refTable="REFERENCE_TABLE.TUNNEL_FUNCTIONAL_CLASSIFICATION"
                v-model="functionalClass"
              />
              <LabelSelect
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="4"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="C.8 Urban Code"
                id="select_Urban_Code"
                :refTable="REFERENCE_TABLE.URBAN_CODE"
                v-model="urbanCode"
              />
            </v-col>
          </v-row>
          <h3 class="withBackground px-2 my-2">Inspection Items</h3>

          <v-row>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <LabelDatefield
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                textXl="4"
                textLg="4"
                textMd="4"
                textSm="4"
                id="txt_Routine_Inspection_Target_Date"
                label="D.1 Routine Inspection Target Date"
                v-model="inspTargetDate"
              >
              </LabelDatefield>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <LabelSelect
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="4"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="D.4 In-Depth Inspection Scheduled?"
                id="select_In-Depth_Inspection_Scheduled"
                :refTable="REFERENCE_TABLE.IN_DEPTH"
                v-model="indepthInspScheduled"
                :showColon="false"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <LabelSelect
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="4"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                id="txtDamage_Inspection_Performed"
                label="D.5 Damage Inspection Performed?"
                :refTable="REFERENCE_TABLE.DAMAGE_PERFORMED"
                v-model="damageInspPerformed"
                :showColon="false"
              />
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <LabelSelect
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="4"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="D.6 Special Inspection Scheduled?"
                id="select_In-Depth_Inspection_Schedule"
                :refTable="REFERENCE_TABLE.IN_DEPTH"
                v-model="specialInspScheduled"
                :showColon="false"
              />
            </v-col>
          </v-row>
          <h3 class="withBackground px-2 my-2">Posting Restriction Items</h3>

          <v-row>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <LabelSelect
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="4"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="L.10 Height Restriction"
                id="select_Height_Restriction"
                :refTable="REFERENCE_TABLE.YES_NO"
                v-model="heightRestriction"
              />
              <LabelSelect
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="4"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="L.11 Hazardous Material Restriction"
                id="select_Hazardous_Material_Restriction"
                :refTable="REFERENCE_TABLE.YES_NO"
                v-model="hazMatRestr"
              />
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <LabelSelect
                labelXl="8"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="4"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="L.12 Other Restrictions"
                id="select_Other_Restrictions"
                :refTable="REFERENCE_TABLE.YES_NO"
                v-model="otherRestr"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel eager value="elements">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="panel.includes('elements')" icon="fa-solid fa-minus" />
          <v-icon v-else icon="fa-solid fa-plus" />
          <h3>Elements</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <InspectionElements
            ref="inspectionElementsRef"
            :inspectionPage="INSPECTION_PAGES.TUNNELS"
            :moduleType="moduleType"
          />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>
<script>
import { ref, computed, onMounted } from "vue";
import InspectionElements from "@/components/inspection/InspectionElements.vue";
import { INSPECTION_PAGES } from "@/constants/Inspections";
import LabelDatefield from "@/components/common/LabelDatefield.vue";
import { useInspectionStore } from "@/stores/inspection";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import LabelText from "@/components/common/LabelText.vue";
import LabelSelect from "@/components/common/LabelSelect.vue";
import ExpandCollapseToggle from "@/components/shared/ExpandCollapseToggle.vue";
import { MODULE_TYPES } from "@/constants/InspectionConstants";
import { useTunnelsStore } from "@/components/inspection/store/tunnels";
import { useQuickSearchStore } from "@/stores/quickSearch";
import { storeToRefs } from "pinia";
import { SNACKBAR_MARKER, SNACKBAR_MESSAGE_TYPES } from "@/constants/GlobalSnackbar.js";
import { useSnackbarStore } from "@/stores/snackbar";
import { STRUCTURE_SEARCH_MESSAGES } from "@/constants/StructureSearches";
import ValidationCountsHeader from "@/components/shared/ValidationCountsHeader.vue";

export default {
  name: "InspectionTunnels",
  props: {
    moduleType: { default: MODULE_TYPES.INSPECTION },
  },
  setup(props) {
    const allPanels = ["tunnelDetails", "elements"];
    const panel = ref(allPanels);
    const inspectionStore = useInspectionStore();
    const tunnelStore = useTunnelsStore();
    const quickSearchStore = useQuickSearchStore();
    const tunnelsValue = ref({});
    const inspectionElementsRef = ref(null);
    const structureHeader = computed(() => quickSearchStore.getStructure());
    const { hasQuickSearchSucceeded } = storeToRefs(quickSearchStore);
    const snackbarStore = useSnackbarStore();

    let numBores = computed(() => tunnelsValue.value?.structureTunnelMaterial?.numBores);
    let tunnelShape = computed(() => tunnelsValue.value?.structureTunnelMaterial?.tunnelShape);
    let portalShape = computed(() => tunnelsValue.value?.structureTunnelMaterial?.portalShape);
    let groundCondition = computed(() => tunnelsValue.value?.structureTunnelMaterial?.groundCondition);
    let complex = computed(() => tunnelsValue.value?.structureTunnelMaterial?.complex);
    let svcInTunnel = computed(() => tunnelsValue.value?.tunnelService?.svcInTunnel);
    let dirOfYTraffic = computed(() => tunnelsValue.value?.tunnelService?.dirOfTraffic);
    let toll = computed(() => tunnelsValue.value?.tunnelService?.toll);
    let functionalClass = computed(() => tunnelsValue.value?.tunnelService?.functionalClass);
    let urbanCode = computed(() => tunnelsValue.value?.tunnelService?.urbanCode);
    let inspTargetDate = computed(() => tunnelsValue.value?.tunnelService?.inspTargetDate);
    let damageInspPerformed = computed(() => tunnelsValue.value?.tunnelService?.damageInspPerformed);
    let specialInspScheduled = computed(() => tunnelsValue.value?.tunnelService?.specialInspScheduled);
    let indepthInspScheduled = computed(() => tunnelsValue.value?.tunnelService?.inDepthInspSchedule);
    let heightRestriction = computed(() => tunnelsValue.value?.tunnelLoadRating?.heightRestr);
    let hazMatRestr = computed(() => tunnelsValue.value?.tunnelLoadRating?.hazmatRestr);
    let otherRestr = computed(() => tunnelsValue.value?.tunnelLoadRating?.otherRestr);
    let snackBarId = ref(null);
    let resetDirty = ref(false);

    const readData = async () => {
      tunnelsValue.value = {};
      resetDirty.value = true;

      let isSuccess = false;
      if (
        props.moduleType == MODULE_TYPES.MANAGEMENT &&
        structureHeader.value?.BRKEY &&
        structureHeader.value.INSPECTIONID
      ) {
        if (!hasQuickSearchSucceeded.value) {
          resetDirty.value = true;
          return;
        }
        isSuccess = await tunnelStore.loadTunnelsObject(
          props.moduleType,
          {
            ...structureHeader.value,
          },
          null
        );
        if (isSuccess) {
          tunnelsValue.value = tunnelStore.getTunnelsObject();
          inspectionElementsRef.value?.readData();
        } else {
          inspectionElementsRef.value?.resetElementsValue();
          showErrorMessage();
        }
      } else if (props.moduleType == MODULE_TYPES.INSPECTION) {
        const structure = computed(() => inspectionStore.selectedInspection);
        await tunnelStore.loadTunnelsObject(props.moduleType, null, structure.value);
        tunnelsValue.value = tunnelStore.getTunnelsObject();
        inspectionStore.setDirtyFlag(false);
      }
      resetDirty.value = true;
    };

    const toggleAllPanels = (expandAll) => {
      if (expandAll) {
        panel.value = allPanels;
      } else {
        panel.value = [];
      }
    };

    const showErrorMessage = () => {
      if ((snackBarId.value === null || snackBarId.value === "") && !quickSearchStore.getErrorMessage()) {
        snackBarId.value = snackbarStore.showMessage({
          displayText: STRUCTURE_SEARCH_MESSAGES.SEARCH_NO_RESULTS,
          messageType: SNACKBAR_MESSAGE_TYPES.ERROR_CUSTOM,
          timeout: 10000,
          callback: () => {
            snackBarId.value = null;
          },
        });
      }
    };
    onMounted(async () => {
      await readData();
    });

    const printD491 = () => {
      return { reportPage: "D491-Insp-Tunnels-Screen", marker: SNACKBAR_MARKER.TUNNELS };
    };
    return {
      panel,
      INSPECTION_PAGES,
      MODULE_TYPES,
      REFERENCE_TABLE,
      numBores,
      tunnelShape,
      portalShape,
      groundCondition,
      complex,
      svcInTunnel,
      dirOfYTraffic,
      toll,
      functionalClass,
      urbanCode,
      inspTargetDate,
      damageInspPerformed,
      specialInspScheduled,
      indepthInspScheduled,
      heightRestriction,
      hazMatRestr,
      otherRestr,
      toggleAllPanels,
      readData,
      inspectionElementsRef,
      tunnelsValue,
      printD491,
    };
  },
  components: {
    LabelText,
    LabelSelect,
    InspectionElements,
    LabelDatefield,
    ExpandCollapseToggle,
    ValidationCountsHeader,
  },
};
</script>
<style scoped lang="scss">
@use "@/styles/colors" as c;

.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.compactCell {
  width: 10%;
  padding: 0px !important;
}
</style>
